// Pure function — no component state dependency.
// Returns array of 4 adjacent positions (null where blocked/same-team).
export function getAdjacentPositions(i, squares, playerPositions) {
  const adjacentPos = Array(4).fill(null);
  const row = Math.floor(i / 9);
  const col = i % 9;

  // left neighbor
  if (col - 1 >= 0 && playerPositions[i - 1] !== playerPositions[i]) {
    adjacentPos[0] = i - 1;
  }
  // right neighbor
  if (col + 1 <= 8 && playerPositions[i + 1] !== playerPositions[i]) {
    adjacentPos[1] = i + 1;
  }
  // top neighbor
  if (row - 1 >= 0 && playerPositions[i - 9] !== playerPositions[i]) {
    adjacentPos[2] = i - 9;
  }
  // bottom neighbor
  if (row + 1 <= 7 && playerPositions[i + 9] !== playerPositions[i]) {
    adjacentPos[3] = i + 9;
  }

  return adjacentPos;
}
